import { useState } from 'react';
import Logo from "../../assets/logo_header.svg";
import { Link } from "react-router-dom";

const NAV_LINKS = [
    { to: "/",           label: "Home" },
    { to: "/company",    label: "Company" },
    { to: "/mission",    label: "Mission" },
    { to: "/services",   label: "Services" },
    { href: "#",         label: "Projects" },
];

const linkClass = "text-white text-lg font-medium no-underline hover:text-accent transition-colors duration-200";
const accentClass = "bg-accent text-black px-2.5 py-1 rounded text-lg font-medium no-underline hover:bg-accent-hover transition-colors duration-200";

export const TopMenu = () => {
    const [open, setOpen] = useState(false);

    return (
        <nav className="bg-navy text-white w-full">
            <div className="flex items-center pt-5 md:pt-20 px-5 pb-5">
                <img
                    src={Logo}
                    alt="Rocky Point Detailing"
                    className="w-full max-w-[200px] md:max-w-[400px]"
                />
                <div className="flex-1" />

                {/* Desktop menu */}
                <div className="hidden md:flex items-center gap-5 pr-10">
                    {NAV_LINKS.map(link =>
                        link.href
                            ? <a key={link.label} href={link.href} className={linkClass}>{link.label}</a>
                            : <Link key={link.to} to={link.to} className={linkClass}>{link.label}</Link>
                    )}
                    <Link to="/contact-us" className={accentClass}>Get a Quote</Link>
                </div>

                {/* Hamburger button */}
                <button
                    className="md:hidden text-white text-3xl leading-none bg-transparent border-none cursor-pointer"
                    onClick={() => setOpen(prev => !prev)}
                    aria-label="Toggle navigation"
                >
                    {open ? '✕' : '☰'}
                </button>
            </div>

            {/* Mobile dropdown */}
            {open && (
                <div className="md:hidden flex flex-col gap-4 px-5 pb-6">
                    {NAV_LINKS.map(link =>
                        link.href
                            ? <a key={link.label} href={link.href} className={linkClass}>{link.label}</a>
                            : <Link key={link.to} to={link.to} className={linkClass} onClick={() => setOpen(false)}>{link.label}</Link>
                    )}
                    <Link to="/contact-us" className={`${accentClass} w-fit`} onClick={() => setOpen(false)}>Get a Quote</Link>
                </div>
            )}
        </nav>
    );
};
